import React, { useRef } from 'react';
import { SecondaryNavView, SecondaryNavViewProps } from './SecondaryNav.view';
import { useLocation } from 'react-router-dom';
import { BreakpointsValuesEnum } from '../../constants/breakpoints-values';
import { useDimensions } from '../../hooks/useDimensions';
import { NewPostRoundButton } from './NewPostRoundButton';
import { useUserData } from 'hooks/useUserData';
import { useSelectedOrganization } from '../../hooks/useSelectedOrganization';
import { getScrollbarWidth } from 'helpers/scrollableHelpers';

export type SecondaryNavControllerProps = Omit<SecondaryNavViewProps, 'Tabs'> & {
  // extend your SecondaryNavViewProps
};

export enum SecondaryMenuItemEnum {
  'publish' = 'publish',
  'discover' = 'discover',
  'analyze' = 'analyze',
  'dev' = 'dev'
}

export type NavigationTabsType = {
  label: string;
  url: string;
};

export const secondNavVisiblePaths: string[] = [
  '/publish/queue',
  '/publish/library',
  '/publish/categories',
  '/publish/categories/archived',
  '/publish/plan',
  '/publish/instagram',
  '/publish/media',
  '/publish/snippets',
  '/discover/auto',
  '/discover/find',
  '/discover/importer',
  '/discover/extension'
];

export const TabNavigationConfig: Record<SecondaryMenuItemEnum, NavigationTabsType[]> = {
  publish: [
    { label: 'Queue', url: '/publish/queue' },
    { label: 'Post Library', url: '/publish/library' },
    { label: 'Categories', url: '/publish/categories' },
    { label: 'Posting Plan', url: '/publish/plan' },
    { label: 'Media Library', url: '/publish/media' },
    { label: 'Snippets', url: '/publish/snippets' },
    { label: 'Instagram Grid', url: '/publish/instagram' }
  ],
  discover: [
    { label: 'Find Content', url: '/discover/find' },
    { label: 'Auto-Importers', url: '/discover/auto' },
    { label: 'Bulk Import from CSV', url: '/discover/importer' },
    { label: 'Chrome Extension', url: '/discover/extension' }
  ],
  analyze: [{ label: 'Overview', url: '/analyze/overview' }],
  dev: [{ label: 'Dev Dashboard', url: '/dev' }]
};

export const SecondaryNavController = (props: SecondaryNavControllerProps): JSX.Element => {
  const location = useLocation();
  const ref = useRef(document.body);
  const { width } = useDimensions(ref);
  const { userData } = useUserData();
  const { selectedOrganization } = useSelectedOrganization();

  const hasWorkspaceSelector =
    (userData?.organizations && userData?.organizations.length > 1) ||
    (selectedOrganization?.workspaces && selectedOrganization?.workspaces.length > 1);
  // If we have a workspace selector, adjust breakponit size
  const breakpoint = hasWorkspaceSelector ? 'large' : 'tabletportrait';
  const scrollbarWidth = getScrollbarWidth();

  if (!secondNavVisiblePaths.includes(location.pathname)) {
    return <></>;
  } else if (width + scrollbarWidth < BreakpointsValuesEnum[breakpoint]) {
    return <NewPostRoundButton />;
  } else {
    const viewProps: SecondaryNavViewProps = {
      ...props,
      Tabs: TabNavigationConfig[location.pathname.split('/')[1] as SecondaryMenuItemEnum]
    };
    return <SecondaryNavView {...viewProps} />;
  }
};
